module.exports = __webpack_public_path__ + "step1_female_to_male.f2f73ca0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step1_female_to_male.jpg
// module id = xZiA
// module chunks = 0